import { Routes, Route } from 'react-router-dom';
import { FAQs } from './resources/FAQs';
import { Research } from './resources/Research';
import { ProfessionalOrganizations } from './resources/ProfessionalOrganizations';

export function Resources() {
  return (
    <Routes>
      <Route index element={<Research />} />
      <Route path="faqs" element={<FAQs />} />
      <Route path="research" element={<Research />} />
      <Route path="professional-organizations" element={<ProfessionalOrganizations />} />
    </Routes>
  );
}